export default function getDataFromSuccessfulResponse<T>(obj: any) {
  return obj?.error !== undefined ? undefined : (obj as T);
};
